<osn-cxb-title-input-control
  [label]="label"
  [languageType]="languageType"
  [formControl]="formControl"
></osn-cxb-title-input-control>
